import {
    AuditActivityDto,
    AuditFiltersResponse,
    AuditInfoRequest
} from '../dtos/activity.dto';
import axiosService from './axios-service';
import { ActivityActionsRequest } from 'src/utils/enums';
import { ActivityLogDownloadInfo } from 'src/dtos/search-criteria.dto';

class ActivityService {

    public getActivity = async (
        customerId: number,
        serviceId: number,
        auditInfoRequest: AuditInfoRequest,
        params: any
    ): Promise<AuditActivityDto[]> => {
        const result = await axiosService.post(`/api/audit/customer/${customerId}/service/${serviceId}`, auditInfoRequest,
            true,
            {
                params
            });
        return result?.data;
    };

    public writeActivityLog = async (activity: ActivityActionsRequest, customerId: number, serviceId: number): Promise<void> => {
        await axiosService.post(`/api/customers/audit/customer/${customerId}/service/${serviceId}/${activity}`);
    };

    public loadFilters = async (customerId: number, serviceId: number): Promise<AuditFiltersResponse> => {
        const result = await axiosService.get(`/api/audit/customer/${customerId}/service/${serviceId}/filters`);
        return result?.data;
    };

    public downloadActivityLogs = async (customerId: number, serviceId: number, auditDownloadInfo: ActivityLogDownloadInfo): Promise<{blob: Blob, fileName: string}>  => {
        const result = await axiosService.post(
            `/api/audit/customer/${customerId}/service/${serviceId}/export`,
            auditDownloadInfo,
            true,
            { responseType: 'blob' });
        let header = result.headers['content-disposition'];
        header = header.replace('attachment;', '');
        header = header.split('=')?.[1]?.replaceAll('"', '');
        return { blob: result.data, fileName: header || `exported_file.${auditDownloadInfo.logsFileType}` };
    };
}

const activityService = new ActivityService();
export default activityService;